import { render, staticRenderFns } from "./Tipocomponente.vue?vue&type=template&id=19bd47db&"
import script from "./Tipocomponente.vue?vue&type=script&lang=js&"
export * from "./Tipocomponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports